import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BaseService } from '../../../shared/services/base.service';
import { SummaryInvestmentAssetMaterialModel } from '../models/summary-investment-asset-material.model';



@Injectable()
export class InvestmentAssetMaterialService extends BaseService<SummaryInvestmentAssetMaterialModel,SummaryInvestmentAssetMaterialModel> {
  constructor(http: HttpClient) {
    super(http, '/api/v2/investment-asset-materials');
  }

}
